import { getSessionImage } from "@kvix/shared";
import { makeStyles } from "@material-ui/core";
import React from "react";
const useStyles = makeStyles((theme) => ({
    liveIcon: {
        position: "absolute",
        fontWeight: "bold",
        top: "5px",
        left: "5px",
        padding: "5px",
        background: theme.palette.common.white,
        color: theme.palette.primary.main,
        borderRadius: "4px"
    },
    viewers: {
        position: "absolute",
        top: "5px",
        right: "5px",
        color: theme.palette.common.white,
        fontWeight: 600,
        display: "flex",
        alignItems: "center"
    },
    imageWrapper: {
        width: "100%",
        height: "100%",
        position: "relative"
    },
    viewersIcon: {
        height: "0.8em",
        width: "0.8em",
        marginTop: "2px",
        marginRight: "3px"
    }
}));
export const SessionPreviewImage = ({ session, live = false }) => {
    const classes = useStyles();
    const sessionImg = getSessionImage(session);
    return (React.createElement("div", { className: classes.imageWrapper },
        session.thumbnailUrl || sessionImg ? (React.createElement("img", { src: (session === null || session === void 0 ? void 0 : session.thumbnailUrl) || sessionImg, alt: "", style: {
                width: "100%",
                height: "100%",
                borderRadius: "3px",
                objectFit: "cover"
            } })) : (React.createElement("div", { style: {
                paddingTop: "56.25%",
                width: "100%",
                borderRadius: "3px",
                backgroundColor: "#5f5e5eb8"
            } })),
        live && React.createElement("div", { className: classes.liveIcon }, "LIVE")));
};
//# sourceMappingURL=SessionPreviewImage.js.map